import type { ICommunity, ICommunityMember } from '@/types/Data'
import type {
  ICreateCommunity,
  IDeleteCommunityMember,
  IGetCommunityAdmin,
  IGetCommunityBySearch,
  IGetCommunityMemberList,
  IInsertCommunityMember,
  IUpdateCommunity,
} from '@/types/Request'
import { JsonToFormData, JsonToFormDataSimple } from '@/utils-ts'
import BaseService from '../BaseService'

export default class CommunityServices extends BaseService {
  GetCommunityList(payload: IGetCommunityAdmin) {
    return this.GET<ICommunity[]>(this.PATHS.GET_COMMUNITY_LIST, payload)
  }

  CreateCommunity(payload: ICreateCommunity) {
    return this.POST<string>(this.PATHS.CREATE_COMMUNITY, JsonToFormData(payload, false))
  }

  UpdateCommunity(payload: IUpdateCommunity) {
    return this.POST<ICommunity>(this.PATHS.UPDATE_COMMUNITY, JsonToFormData(payload, false))
  }

  DeleteCommunity(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_COMMUNITY, { Id })
  }

  GetCommunityMemberList(payload: IGetCommunityMemberList) {
    return this.GET<ICommunityMember[]>(this.PATHS.GET_COMMUNITY_MEMBER_LIST, payload)
  }

  InsertCommunityMember(payload: IInsertCommunityMember) {
    return this.POST<void>(this.PATHS.INSERT_COMMUNITY_MEMBER, JsonToFormDataSimple(payload))
  }

  DeleteCommunityMember(payload: IDeleteCommunityMember) {
    return this.DELETE<void>(this.PATHS.DELETE_COMMUNITY_MEMBER, payload)
  }

  GetCommunityBySearch(payload: IGetCommunityBySearch) {
    return this.GET<ICommunity[]>(this.PATHS.GET_COMMUNITY_BY_SEARCH, payload)
  }
}
